import * as Yup from 'yup';
import { SarlaftVinculationExist } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftVinculationExist = {
    policyHolderInsured: '',
    policyHolderBeneficiary: '',
    insuredBeneficiary: '',
};

export const validationSchema = Yup.object({
    policyHolderInsured: Yup.string().required(
        'El tomador asegurado es obligatorio'
    ),
    policyHolderBeneficiary: Yup.string().required(
        'El tomador beneficiario es obligatorio'
    ),
    insuredBeneficiary: Yup.string().required(
        'El asegurado beneficiario obligatorio'
    ),
});
